/* eslint-disable camelcase */
import FileDownload from './file-download';
import { getFilesizeLabel } from '../../utilities/file';
import PropTypes from 'prop-types';
import React from 'react';

const FileGroup = ({ files, title = '' }) => {
    return (
        <section className="content-block || file-group-block || constrain-width">
            <hr />
            <div className="container">
                <div className="col-title">
                    {title &&
                        <h2 className="h4">{title}</h2>
                    }
                </div>

                <div className="col-files">
                    {files.map(({
                        id,
                        display_name,
                        extension,
                        file,
                        filename,
                        filesize,
                    }) => (
                        <div className="file-row" key={id}>
                            <span className="filename">{display_name || filename}</span>
                            <div className="fileinfo">
                                <span className="filesize">{`${getFilesizeLabel(filesize)} (${extension.toUpperCase()})`}</span>
                                <a className="primary button inverse" href={file} download={filename} target="_blank" rel="noreferrer">Download</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

FileGroup.propTypes = {
    title: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.shape(FileDownload.propTypes)).isRequired,
};

export default FileGroup;
